import { useState, useEffect, useMemo } from "react";
import DownIcon from "./down.js";
import { useSelector, useDispatch } from "react-redux";
import RadarChart from "./radarChart";
import HeatmapComponent from "./heatMap";
import { useNavigate } from "react-router-dom";

import { updateTabPath } from "../../../store/actions";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export function processSurveyAnswers(surveyAnswers) {

  const questionMap = {};
  const userPageScores = {};
  const userSectionScores = {};
  const userQuestionScores = {};

  // Kullanıcı bazlı skorları hesapla
  surveyAnswers.forEach(({ user_id, answers }) => {
    const pageScores = {};
    const sectionScores = {};
    const questionScores = {};

    answers.forEach(({ page, score, type, section, question }) => {
      if (type === "rating") console.log(answers);

      // Section bazlı puanları topla
      if (section) {
        sectionScores[section] = sectionScores[section] || [];
        sectionScores[section].push(score);
      }

      // Page bazlı puanları section altında gruplandırarak topla
      if (section && page) {
        pageScores[section] = pageScores[section] || {};
        pageScores[section][page] = pageScores[section][page] || [];
        pageScores[section][page].push(score);
      }

      // Question bazlı puanları section altında gruplandırarak topla
      if (page && question) {
        questionScores[page] = questionScores[page] || {};
        questionScores[page][question] = questionScores[page][question] || [];
        questionScores[page][question].push(score);
      }
    });

    userPageScores[user_id] = pageScores;
    userSectionScores[user_id] = sectionScores;
    userQuestionScores[user_id] = questionScores;
  });
  console.log("questionmap",questionMap)
  // Seçenek bazlı oranları hesapla
  surveyAnswers.forEach(({ user_id, answers }) => {
    answers.forEach(
      ({ question_id, section, question, answer, options, type, page, rateCount }) => {
        if (type === "comment" || type === "tagbox" || type === "checkbox" || type === "ranking" || type === "boolean" || type === "text") return;

        if (!questionMap[question_id]) {
          questionMap[question_id] = {
            question_id,
            section,
            question,
            page,
            options:type === "rating" && rateCount
              ? Array.from({ length: rateCount }, (_, i) => ({
                  opt: (i + 1).toString(), // 1'den ratecount'a kadar numaralar
                  scores: { section: {}, page: {}, question: {} },
                }))
              : options?.map((option) => ({
                  opt: option,
                  scores: { section: {}, page: {}, question: {} },
                })),
        };
        }
console.log(questionMap)
        const questionData = questionMap[question_id];
        const optionIndex = questionData.options?.findIndex(
          (opt) => opt.opt == answer.toString()
        );
console.log("dsa",optionIndex,type)
        if (optionIndex !== -1) {
          const matchingUsers = surveyAnswers.filter(({ answers }) =>
            answers.some(
              (a) => a.question_id === question_id && a.answer === answer
            )
          );

          matchingUsers.forEach(({ user_id: matchedUserId }) => {
            // Section bazlı oranları hesapla
            if (userSectionScores[matchedUserId]) {
              Object.entries(userSectionScores[matchedUserId]).forEach(
                ([userSection, scores]) => {
                  questionData.options[optionIndex].scores.section[
                    userSection
                  ] = [
                      ...(questionData.options[optionIndex].scores.section[
                        userSection
                      ] || []),
                      ...scores,
                    ];
                }
              );
            }

            // Page bazlı oranları section içinde hesapla
            if (userPageScores[matchedUserId]) {
              Object.entries(userPageScores[matchedUserId]).forEach(
                ([userSection, pages]) => {
                  Object.entries(pages).forEach(([userPage, scores]) => {
                    console.log(11111111111)
                    // console.log("userPage", userPage);
                    // console.log("scores", scores);
                    // console.log("userSection", userSection);
                    if (
                      !questionData.options[optionIndex].scores.page[userSection]
                    ) {
                      questionData.options[optionIndex].scores.page[userSection] = {};
                    }
                    questionData.options[optionIndex].scores.page[userSection][userPage] = [
                        ...(questionData.options[optionIndex].scores.page[userSection][userPage] || []),
                        ...scores,
                      ];
                  });
                }
              );
            }

            // Question bazlı oranları section içinde hesapla
            if (userQuestionScores[matchedUserId]) {
              Object.entries(userQuestionScores[matchedUserId]).forEach(
                ([userSection, questions]) => {
                  Object.entries(questions).forEach(
                    ([userQuestion, scores]) => {
                      if (
                        !questionData.options[optionIndex].scores.question[
                        userSection
                        ]
                      ) {
                        questionData.options[optionIndex].scores.question[
                          userSection
                        ] = {};
                      }
                      questionData.options[optionIndex].scores.question[
                        userSection
                      ][userQuestion] = [
                          ...(questionData.options[optionIndex].scores.question[
                            userSection
                          ][userQuestion] || []),
                          ...scores,
                        ];
                    }
                  );
                }
              );
            }
          });
        }
      }
    );
  });
console.log("pagescore",questionMap)
  // Ortalama skorları hesapla ve sonucu döndür
  return Object.values(questionMap).map(
    ({ question_id, section, question, page, options }) => ({
      question_id,
      section,
      question,
      page,
      options: options.map(({ opt, scores }) => {
        const averagedScores = { section: {}, page: {}, question: {} };

        // Section bazlı ortalama hesapla
        Object.entries(scores.section).forEach(([sec, scoreList]) => {
          averagedScores.section[sec] = scoreList.length
            ? scoreList.reduce((a, b) => a + b, 0) / scoreList.length
            : 0;
        });

        // Page bazlı ortalama section içinde hesapla
        Object.entries(scores.page).forEach(([sec, pages]) => {
          averagedScores.page[sec] = {};
          Object.entries(pages).forEach(([pg, scoreList]) => {
            averagedScores.page[sec][pg] = scoreList.length
              ? scoreList.reduce((a, b) => a + b, 0) / scoreList.length
              : 0;
          });
        });

        // Question bazlı ortalama section içinde hesapla
        Object.entries(scores.question).forEach(([sec, questions]) => {
          averagedScores.question[sec] = {};
          Object.entries(questions).forEach(([qst, scoreList]) => {
            averagedScores.question[sec][qst] = scoreList.length
              ? scoreList.reduce((a, b) => a + b, 0) / scoreList.length
              : 0;
          });
        });

        return { opt, scores: averagedScores };
      }),
    })
  );
}
export default function Insight() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log(2);
  const themeMode = useSelector((state) => state.themeMode);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;
  console.log(topMenuTabs);
  const currentSurveyInsightData = useMemo(() => {
    const activeTab = topMenuTabs.tabs.find(
      (tab) => tab.id === topMenuTabs.activeTab
    );
    return activeTab ? activeTab.states.currentSurveyInsightData : null;
  }, [topMenuTabs.tabs, topMenuTabs.activeTab]);
  console.log(currentSurveyInsightData);
  const [leftPercentage, setLeftPercentage] = useState(0);
  const [stages, setStages] = useState([
    {
      name: "Initial",
      active: false,
    },
    {
      name: "Under Development",
      active: false,
    },
    {
      name: "Defined",
      active: false,
    },
    {
      name: "Managed",
      active: false,
    },
    {
      name: "Measured",
      active: false,
    },
  ]);
  const [selectedPage, setSelectedPage] = useState(
    "General Usage of Generative AI"
  );
  const [selectedQuestion, setSelectedQuestion] = useState("Select a question");
  useEffect(() => {
    console.log("currentSurveyInsightData", currentSurveyInsightData);
    if (
      currentSurveyInsightData &&
      currentSurveyInsightData?.report_detail?.scores?.overall
    ) {
      const survey_answers =
        currentSurveyInsightData?.report_detail?.survey_answers;
      if (survey_answers) {
        const processedAnswers = processSurveyAnswers(survey_answers);
        if (JSON.stringify(processedAnswers) !== JSON.stringify(totalAnswers)) {
          setTotalAnswers(processedAnswers);
          console.log("Processed Answers:", processedAnswers);
        }
        // setTotalAnswers(processedAnswers);

        console.log("Processed Answers:", processedAnswers);
      }
      console.log(
        currentSurveyInsightData?.report_detail?.scores?.overall * 20
      );
      setLeftPercentage(
        currentSurveyInsightData?.report_detail?.scores?.overall * 20
      );
      const newStages = JSON.parse(JSON.stringify(stages));
      const overallIndex = parseInt(
        currentSurveyInsightData.report_detail.scores.overall
      );
      newStages.forEach((stage, index) => {
        if (stage.active) {
          newStages[index].active = false;
        }
      });
      if (!newStages[overallIndex].active) {
        // Sadece aktif değilse güncelle
        newStages[overallIndex].active = true;
        setStages(newStages);
        console.log("_stages updated:", newStages);
      }
    }
  }, [currentSurveyInsightData]);
  console.log(currentSurveyInsightData);
  const radarChartData = [
    {
      name: "Series 1",
      data: currentSurveyInsightData?.report_detail?.scores?.sections?.map(
        (x) => x.score
      ),
    },
  ];
  const [totalAnswers, setTotalAnswers] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);

  return (
    <div
      className={`flex flex-col w-full pl-4 ${themeMode === "dark"
        ? "bg-[#1a1a28] text-white"
        : "bg-[#fbfbfc] text-black"
        }`}
    >
      {currentSurveyInsightData?.report_detail?.scores !== undefined && (
        <div className="flex justify-start w-full pr-4 flex-col 2xl:flex-row ">
          <div className="xl:w-[100%] 2xl:w-[75%] flex flex-col">
            <div className="flex-col flex lg:flex-col gap-4">
              <div className="items-top lg:text-start flex-1  mt-4 flex flex-row space-x-12 pr-12">
                <div
                  className={`shadow-md rounded-lg pt-2 px-0 pb-0 lg:w-{[400px]} h-[150px]  sm:min-w-[150px] w-2/3  
                          bg-white text-gray-800 cursor-pointer
                            `}
                >
                  <div className="p-4 py-1 rounded-lg space-y-0">
                    <div className="flex justify-between items-center mb-0">
                      <span className="size-5 whitespace-nowrap text-lg font-bold text-[#1a1a28] flex flex-grow">
                        OVERALL SCORE
                      </span>
                    </div>
                    <div className="flex justify-between items-center mb-0 flex-wrap">
                      <p className="text-[30px] sm:text-[64px] font-bold text-[#44a5e4]">
                        {" "}
                        {currentSurveyInsightData?.report_detail?.scores?.overall.toFixed(
                          2
                        )}
                      </p>
                      <span
                        className="size-5 whitespace-nowrap font-bold text-xs sm:text-[20px] text-[#4a4a4a] flex flex-grow justify-end min-w-0 text-ellipsis"
                        title={
                          stages[
                            parseInt(
                              currentSurveyInsightData?.report_detail?.scores
                                ?.overall
                            )
                          ].name
                        }
                      >
                        {stages[
                          parseInt(
                            currentSurveyInsightData?.report_detail?.scores
                              ?.overall
                          )
                        ].name.length > 10
                          ? stages[
                            parseInt(
                              currentSurveyInsightData?.report_detail?.scores
                                ?.overall
                            )
                          ].name.substring(0, 10) + "..."
                          : stages[
                            parseInt(
                              currentSurveyInsightData?.report_detail?.scores
                                ?.overall
                            )
                          ].name}
                      </span>
                    </div>
                    <div className="relative w-full bg-transparent h-[13px]">
                      <div
                        className="bg-custom-gradient h-[13px]"
                        style={{ width: `${leftPercentage}%` }}
                      ></div>
                      <div
                        className="absolute bg-[#596877] top-[0px] h-[13px] z-20"
                        style={{
                          left: `${leftPercentage}%`,
                          width: `${100 - leftPercentage}%`,
                        }}
                      ></div>
                      <div
                        className="absolute top-[-8px] h-[5rem] w-10 transform -translate-x-1/2 z-20"
                        style={{ left: `${leftPercentage}%` }}
                      >
                        <DownIcon className={`w-8 h-8 `} stroke="2" fill="#fff" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`shadow-md rounded-lg pt-2 px-0 pb-0 w-full  lg:w-full min-w-[150px] h-[150px]
                            ${themeMode === "dark"
                      ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                      : "bg-white text-gray-800 cursor-pointer"
                    }
                              
                            `}
                >
                  <div className="p-4 py-1 rounded-lg">
                    <div className="flex justify-between items-center mb-3">
                      <div className="flex items-center">
                        <span
                          className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                            }`}
                        >
                          Stages
                        </span>
                      </div>
                    </div>

                    <div
                      className={` sm:block overflow-x-auto overflow-y-hidden   flex justify-center sm:justify-start   mt-8  h-[50px]  px-0 w-full`}
                    >
                      <div
                        aria-label="Tabs"
                        className={`  flex items-center w-full flex-nowrap flex-shrink-0 min-w-0 gap-[0.25rem] rounded-[0.375rem] flex-1   ${themeMode === "dark"
                          ? "bg-[#a5bdff0d]"
                          : "bg-[#1530720d] "
                          }`}
                      >
                        {stages.map((stage, index) => (
                          <div
                            key={stage.name}
                            className={classNames(
                              stage.active
                                ? themeMode === "dark"
                                  ? "bg-[#19b394] text-[#FFFFFF] flex justify-center items-center flex-nowrap flex-shrink-0  hover:text-[#FFFFFF]"
                                  : "bg-[#A5BDFF26] text-[#5a667e] flex justify-center items-center flex-nowrap flex-shrink-0  hover:text-[#000] "
                                : themeMode === "dark"
                                  ? " bg-[#292d32] flex justify-center items-center flex-nowrap flex-shrink-0 hover:rounded-[0.375rem] text-[#C1C9D6] hover:bg-[#a5bdff10] hover:text-[#FFFFFF]"
                                  : "flex justify-center items-center flex-nowrap flex-shrink-0 hover:rounded-[0.375rem] text-[#5a667e] hover:bg-gray-200 hover-text-[#000]",
                              // (Object.keys(currentSurveyResult).length === 0 && tab.name === "Insight") ? "cursor:auto pointer-events-none opacity-50" : "",
                              "group inline-flex items-center  py-2 pl-2 pr-2 text-xs sm:text-sm font-medium w-auto flex flex-1 h-[50px] "
                            )}
                          >
                            <span>{stage.name}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`w-full mt-4 flex flex-1 flex-row items-top space-x-12 
                ${(currentSurveyInsightData?.report_detail?.scores?.sections?.length) > 2 
                  ? "pr-12"
                  : "pr-4"
                }
                `}>
                <div
                  className={`mt-0 shadow-md rounded-lg px-4 pt-0  sm:min-w-[150px] lg:w-{[400px]}  w-2/3 max-h-[400px]
                          cursor-pointer   ${themeMode === "dark"
                      ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                      : "bg-white text-gray-800 cursor-pointer"
                    }
                    ${(currentSurveyInsightData?.report_detail?.scores?.sections?.length) > 2 
                      ? "w-2/3 mt-8"
                      : "w-full"
                    }
                    `}
                >
                  <div className="flex justify-between items-center mb-3">
                    <span
                      className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold pt-2  ${themeMode === "dark"
                        ? "text-[#FFFFFF]"
                        : "text-gray-800"
                        }`}
                    >
                      Overview
                    </span>
                  </div>
                  <article className=" flex flex-col space-y-8 pt-2  overflow-y-scroll     max-h-[370px] ">
                    <p className="text-md  text-balance ">
                      {
                        currentSurveyInsightData?.report_detail
                          ?.overview_comment
                      }
                    </p>
                  </article>
                </div>
                {currentSurveyInsightData?.report_detail?.scores?.sections?.length > 2 && (
                  <RadarChart
                    className="mt-0 py-0 w-full"
                    series={radarChartData}
                    categories={currentSurveyInsightData?.report_detail?.scores?.sections?.map(
                      (x) => x.name
                    )}
                    themeMode={themeMode}
                  />
                )}
              </div>
            </div>
            <div className="flex flex-col ">
              <div className="flex w-full flex-col md:flex-row sm:space-x-8 pr-4 mt-4">
                <div className="w-full md:w-1/2 text-start  mt-4 flex flex-col">
                  <div
                    className={`shadow-md rounded-lg pt-2 px-0 pb-4 w-full min-w-[150px] h-auto 
                          ${themeMode === "dark"
                        ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                        : "bg-white text-gray-800 cursor-pointer"
                      }
                            
                          `}
                  >
                    <div className="p-4 py-1 rounded-lg space-y-8">
                      <div className="flex justify-between items-center mb-3">
                        <span
                          className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold  ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                            }`}
                        >
                          Strengths
                        </span>
                      </div>
                      <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                        <div className="flex justify-between space-x-16 items-center px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              1
                            </span>
                            <p
                              className={`text-md  font ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData?.report_detail
                                  ?.strengths[0]
                              }
                            </p>
                          </div>
                        </div>
                        <div className="flex  space-x-16 items-center justify-between pt-2 px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              2
                            </span>
                            <p
                              className={`text-md  font- ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData?.report_detail
                                  ?.strengths[1]
                              }
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-between space-x-16 items-center pt-2 px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              3
                            </span>
                            <p
                              className={`text-md  font ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData?.report_detail
                                  ?.strengths[2]
                              }
                            </p>
                          </div>
                          {/* <span
                            className={`text-md  font-bold ${
                              themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                            }`}
                          >
                            4.2
                          </span> */}
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full justify-end pr-4 pt-4">
                      <button
                        className={`  w-16 h-[25px] text-[14px] ${themeMode === "dark"
                          ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                          : "border-[#1725471a] bg-[#BCBCBC] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                          }`}
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                          dispatch(updateTabPath(topMenuTabs.activeTab, 'Strengths & Weaknesses', `/surveys/${currentSurvey.ID}/insight-strengths-weaknesses`));
                          navigate("/surveys/" + currentSurvey.ID + "/insight-strengths-weaknesses");
                        }}
                      >
                        DETAIL
                      </button>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/2 text-start  mt-4 flex flex-col">
                  <div
                    className={`shadow-md rounded-lg pt-2 px-0 pb-4 w-full min-w-[150px] h-auto 
                          ${themeMode === "dark"
                        ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                        : "bg-white text-gray-800 cursor-pointer"
                      }
                            
                          `}
                  >
                    <div className="p-4 py-1 rounded-lg space-y-8">
                      <div className="flex justify-between items-center mb-3">
                        <span
                          className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                            }`}
                        >
                          Weakness
                        </span>
                      </div>
                      <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                        <div className="flex justify-between space-x-16 items-center px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              1
                            </span>
                            <p
                              className={`text-md  ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData?.report_detail
                                  ?.weaknesses[0]
                              }
                            </p>
                          </div>
                        </div>
                        <div className="flex  space-x-16 justify-between items-center pt-2 px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              2
                            </span>
                            <p
                              className={`text-md   ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData?.report_detail
                                  ?.weaknesses[1]
                              }
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-between space-x-16 items-center pt-2 px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              3
                            </span>
                            <p
                              className={`text-md   ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData?.report_detail
                                  ?.weaknesses[2]
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full justify-end pr-4 pt-4">
                      <button
                        className={`  w-16 h-[25px] text-[14px] ${themeMode === "dark"
                          ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                          : "border-[#1725471a] bg-[#BCBCBC] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                          }`}
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                          dispatch(updateTabPath(topMenuTabs.activeTab, 'Strengths & Weaknesses', `/surveys/${currentSurvey.ID}/insight-strengths-weaknesses`));
                          navigate("/surveys/" + currentSurvey.ID + "/insight-strengths-weaknesses");
                        }}
                      >
                        DETAIL
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full text-start  mt-4 flex flex-col pr-4 mt-4">
                <div
                  className={`shadow-md rounded-lg pt-2 px-0 pb-4 w-full min-w-[150px] h-auto 
                          ${themeMode === "dark"
                      ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer"
                      : "bg-white text-gray-800 cursor-pointer"
                    }
                            
                          `}
                >
                  <div className="p-4 py-1 rounded-lg space-y-8">
                    <div className="flex justify-between items-center mb-3">
                      <span
                        className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark"
                          ? "text-[#FFFFFF]"
                          : "text-gray-800"
                          }`}
                      >
                        Findings
                      </span>
                    </div>
                    <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                      <div className="flex justify-between space-x-16 items-center px-2">
                        <div className="flex justify-start space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            1
                          </span>
                          <p
                            className={`text-md   ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData?.report_detail
                                ?.findings[0]?.finding
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                      <div className="flex  space-x-16 justify-between items-center pt-2 px-2">
                        <div className="flex justify-between space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            2
                          </span>
                          <p
                            className={`text-md   ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData?.report_detail
                                ?.findings[1]?.finding
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                      <div className="flex justify-between space-x-16 items-center pt-2 px-2">
                        <div className="flex justify-start space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            3
                          </span>
                          <p
                            className={`text-md  ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData?.report_detail
                                ?.findings[2]?.finding
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full justify-end pr-4 pt-4">
                    <button
                      className={`  w-16 h-[25px] text-[14px] ${themeMode === "dark"
                        ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                        : "border-[#1725471a] bg-[#BCBCBC] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                        }`}
                      onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        dispatch(updateTabPath(topMenuTabs.activeTab, 'Findings', `/surveys/${currentSurvey.ID}/insight-findings`));
                        navigate("/surveys/" + currentSurvey.ID + "/insight-findings");
                      }}
                    >
                      DETAIL
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-full text-start  mt-4 flex flex-col pr-4">
                <div
                  className={`shadow-md rounded-lg pt-2 px-0 pb-4 w-full min-w-[150px] h-auto 
                          ${themeMode === "dark"
                      ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer"
                      : "bg-white text-gray-800 cursor-pointer"
                    }
                            
                          `}
                >
                  <div className="p-4 py-1 rounded-lg space-y-8">
                    <div className="flex justify-between items-center mb-3">
                      <span
                        className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark"
                          ? "text-[#FFFFFF]"
                          : "text-gray-800"
                          }`}
                      >
                        Recommendations
                      </span>
                    </div>
                    <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                      <div className="flex justify-between space-x-16 items-center px-2">
                        <div className="flex justify-start space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            1
                          </span>
                          <p
                            className={`text-md   ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData?.report_detail
                                ?.recommendations[0]?.recommendation
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                      <div className="flex  space-x-16 justify-between items-center pt-2 px-2">
                        <div className="flex justify-between space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            2
                          </span>
                          <p
                            className={`text-md  ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData?.report_detail
                                ?.recommendations[1]?.recommendation
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                      <div className="flex justify-between space-x-16 items-center pt-2 px-2">
                        <div className="flex justify-start space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            3
                          </span>
                          <p
                            className={`text-md   ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData?.report_detail
                                ?.recommendations[2]?.recommendation
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full justify-end pr-4 pt-4">
                    <button
                      className={`  w-16 h-[25px] text-[14px] ${themeMode === "dark"
                        ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                        : "border-[#1725471a] bg-[#BCBCBC] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                        }`}
                    // onClick={() => {
                    //   navigate("/surveys/" + currentSurvey.ID + "/recommendations");
                    // }}
                    >
                      DETAIL
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {totalAnswers.length > 0 && (
              <div
                className={`flex flex-0 w-auto 2xl:flex-1 w-auto text-start flex-col pr-4 pb-8`}
              >
                <HeatmapComponent
                  totalData={totalAnswers}
                  themeMode={themeMode}
                />
              </div>
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:flex xl:flex-row 2xl:flex-col gap-2 w-[100%] ml-0 px-0 mx-0 2xl:w-[20%]">
            {currentSurveyInsightData?.report_detail?.scores?.sections?.map(
              (section, index) => (
                <div key={index} className=" text-start  mt-4 flex flex-col">
                  <div
                    className={`shadow-md rounded-lg pt-2 px-0 pb-0 w-full min-w-[150px] h-[150px]  text-[20px]
                        ${themeMode === "dark"
                        ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                        : "bg-white text-gray-800 cursor-pointer"
                      }
                          
                        `}
                  >
                    <div className="p-4 py-1 rounded-lg space-y-8">
                      <div className="flex justify-between items-center mb-3">
                        <span
                          className={`size-5 w-full truncate text-sm sm:text-[16px] 3xl:[text-20px]  font-bold   ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                            }`}
                        >
                          {section.name.length > 20
                            ? section.name.slice(0, 20) + "..."
                            : section.name}
                        </span>
                      </div>
                      <div className="flex justify-between items-center mb-3">
                        <p className="text-sm sm:text-[48px] font-bold text-[#44A5E4] ">
                          {" "}
                          {section.score.toFixed(2)}
                        </p>
                      </div>
                      <div className="relative w-full bg-transparent h-[13px] ">
                        <div
                          className={`bg-custom-gradient h-[13px]`}
                          style={{ width: `${section.score * 20}%` }}
                        ></div>
                        <div
                          className={`absolute bg-[#596877] top-[0px] h-[13px] z-20`}
                          style={{
                            left: `${section.score * 20}%`,
                            width: `${100 - section.score * 20}%`,
                          }}
                        ></div>
                        <div
                          className={`absolute top-[-8px] h-[5rem] w-10 transform -translate-x-1/2 z-20 `}
                          style={{ left: `${section.score * 20}%` }}
                        >
                          <DownIcon className={`w-8 h-8 `} stroke="2" fill="#fff" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}
